import { render, staticRenderFns } from "./UserAnalyticsWidget.vue?vue&type=template&id=44fdbcb1"
import script from "./UserAnalyticsWidget.vue?vue&type=script&lang=js"
export * from "./UserAnalyticsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports